<div class="flex flex-col sm:w-80vw h-screen sm:h-auto max-h-screen" *transloco="let t; read: 'expression-settings'">
  <div class="flex flex-row items-center place-content-between p-4">
    <div class="flex flex-col space-y-2">
      <span class="text-3xl font-bold">{{ t("CONDITIONAL_DIALOG_TITLE") }}</span>
    </div>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="flex flex-col space-y-4 p-4 h-full overflow-y-auto">
    <mat-form-field class="w-full fuse-mat-dense-subscript">
      <mat-label>{{t("FIELD_NAME")}}</mat-label>
      <input required matInput [(ngModel)]="conditional.name"/>
    </mat-form-field>

    <predicate-component [formDefinition]="formDefinition" [predicate]="conditional.predicate"></predicate-component>

    <div class="flex flex-col p-4 space-y-4 border rounded-sm shadow-sm bg-gray-50">
      <div [innerHtml]="t('POSITIVE_ACTION_TITLE')"></div>

      <div class="flex flex-row items-center space-x-2"
           *ngFor="let fieldAction of conditional.positiveActions; let i = index">
        <mat-form-field class="w-60 fuse-mat-dense-subscript">
          <mat-select [(value)]="fieldAction.action">
            <mat-option [value]="action"
                        *ngFor="let action of possibleActions">{{ t('action.' + action)}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-60 fuse-mat-dense-subscript">
          <mat-select [(value)]="fieldAction.field">
            <mat-option [value]="field"
                        *ngFor="let field of getAvailableFields(conditional.positiveActions, fieldAction)">{{field.label}}</mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-icon-button (click)="removePositiveAction(fieldAction)">
          <mat-icon svgIcon="heroicons_solid:trash"></mat-icon>
        </button>

      </div>

      <button class="self-start" mat-stroked-button (click)="newPositiveAction()">
        {{t("ACTION_ADD_OTHER_ACTION")}}
      </button>
    </div>

    <div class="flex flex-col p-4 space-y-4 border rounded-sm shadow-sm bg-gray-50">
      <div [innerHtml]="t('NEGATIVE_ACTION_TITLE')"></div>
      <div class="flex flex-row items-center space-x-2"
           *ngFor="let fieldAction of conditional.negativeActions; let i = index">
        <mat-form-field class="w-60 fuse-mat-dense-subscript">
          <mat-select [(value)]="fieldAction.action">
            <mat-option [value]="action"
                        *ngFor="let action of possibleActions">{{ t('action.' + action)}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-60 fuse-mat-dense-subscript">
          <mat-select [(value)]="fieldAction.field">
            <mat-option [value]="field"
                        *ngFor="let field of getAvailableFields(conditional.negativeActions, fieldAction)">{{field.label}}</mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-icon-button (click)="removeNegativeAction(fieldAction)">
          <mat-icon svgIcon="heroicons_solid:trash"></mat-icon>
        </button>

      </div>

      <button class="self-start" mat-stroked-button  (click)="newNegativeAction()">
        {{t("ACTION_ADD_OTHER_ACTION")}}
      </button>
    </div>

  </div>
  <div class="flex flex-row items-center place-content-end m-4">
    <button mat-button mat-dialog-close>
      {{ t("ACTION_CANCEL") }}
    </button>
    <button mat-button color="primary" (click)="save()" [disabled]="!conditional.isValid()">
      {{ t("ACTION_SAVE") }}
    </button>
  </div>
</div>